import { useState } from 'react'
import { Save, Key, Database, Webhook } from 'lucide-react'

export default function SettingsPage() {
  const [settings, setSettings] = useState({
    openai_key: '',
    stripe_key: '',
    sendgrid_key: '',
    database_url: '',
    zapier_webhook: '',
  })

  const handleSave = () => {
    // Save to localStorage or API
    localStorage.setItem('bot_settings', JSON.stringify(settings))
    alert('설정이 저장되었습니다!')
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <h1 className="text-3xl font-bold text-white">⚙️ 설정</h1>

      <div className="bg-slate-800 rounded-lg p-6 space-y-6">
        <div>
          <div className="flex items-center mb-3">
            <Key className="h-5 w-5 text-sky-500 mr-2" />
            <h3 className="text-lg font-semibold text-white">API 키</h3>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-gray-400 mb-2">OpenAI API Key</label>
              <input
                type="password"
                value={settings.openai_key}
                onChange={(e) => setSettings({ ...settings, openai_key: e.target.value })}
                placeholder="sk-..."
                className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg"
              />
            </div>

            <div>
              <label className="block text-gray-400 mb-2">Stripe Secret Key</label>
              <input
                type="password"
                value={settings.stripe_key}
                onChange={(e) => setSettings({ ...settings, stripe_key: e.target.value })}
                placeholder="sk_test_..."
                className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg"
              />
            </div>

            <div>
              <label className="block text-gray-400 mb-2">SendGrid API Key</label>
              <input
                type="password"
                value={settings.sendgrid_key}
                onChange={(e) => setSettings({ ...settings, sendgrid_key: e.target.value })}
                placeholder="SG...."
                className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-6">
          <div className="flex items-center mb-3">
            <Database className="h-5 w-5 text-sky-500 mr-2" />
            <h3 className="text-lg font-semibold text-white">데이터베이스</h3>
          </div>
          
          <div>
            <label className="block text-gray-400 mb-2">Database URL</label>
            <input
              type="text"
              value={settings.database_url}
              onChange={(e) => setSettings({ ...settings, database_url: e.target.value })}
              placeholder="postgresql://..."
              className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg"
            />
          </div>
        </div>

        <div className="border-t border-slate-700 pt-6">
          <div className="flex items-center mb-3">
            <Webhook className="h-5 w-5 text-sky-500 mr-2" />
            <h3 className="text-lg font-semibold text-white">웹훅</h3>
          </div>
          
          <div>
            <label className="block text-gray-400 mb-2">Zapier Webhook URL</label>
            <input
              type="text"
              value={settings.zapier_webhook}
              onChange={(e) => setSettings({ ...settings, zapier_webhook: e.target.value })}
              placeholder="https://hooks.zapier.com/..."
              className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg"
            />
          </div>
        </div>

        <button
          onClick={handleSave}
          className="w-full flex items-center justify-center px-6 py-3 bg-sky-600 text-white rounded-lg hover:bg-sky-700"
        >
          <Save className="h-5 w-5 mr-2" />
          설정 저장
        </button>
      </div>

      <div className="bg-slate-800 rounded-lg p-6">
        <h3 className="text-lg font-bold text-white mb-3">📋 Cloudflare 배포 가이드</h3>
        <div className="space-y-3 text-gray-400 text-sm">
          <div className="bg-slate-900 rounded p-3">
            <p className="font-mono"># 1. Wrangler 설치</p>
            <p className="font-mono">npm install -g wrangler</p>
          </div>
          <div className="bg-slate-900 rounded p-3">
            <p className="font-mono"># 2. Cloudflare 로그인</p>
            <p className="font-mono">wrangler login</p>
          </div>
          <div className="bg-slate-900 rounded p-3">
            <p className="font-mono"># 3. D1 데이터베이스 생성</p>
            <p className="font-mono">wrangler d1 create marketing_bot</p>
          </div>
          <div className="bg-slate-900 rounded p-3">
            <p className="font-mono"># 4. Worker 배포</p>
            <p className="font-mono">npm run worker:deploy</p>
          </div>
          <div className="bg-slate-900 rounded p-3">
            <p className="font-mono"># 5. Pages 배포</p>
            <p className="font-mono">npm run deploy</p>
          </div>
        </div>
      </div>
    </div>
  )
}
